// apps/frontend/src/components/notifications/PushPermissionPrompt.tsx
// Banniere pour activer les notifications push — affichee dans NotificationBell

import React, { useState, useEffect } from 'react';
import { BellRing, X } from 'lucide-react';
import {
  isPushSupported,
  isPushSubscribed,
  isPushDenied,
  isPushPromptDismissed,
  dismissPushPrompt,
  subscribeToPush,
} from '../../services/pushService';

const PushPermissionPrompt: React.FC = () => {
  const [visible, setVisible] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      if (!isPushSupported() || isPushDenied() || isPushPromptDismissed())
        return;
      const subscribed = await isPushSubscribed();
      if (!cancelled && !subscribed) setVisible(true);
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  if (!visible) return null;

  const handleEnable = async () => {
    setLoading(true);
    const token = localStorage.getItem('glowp_access_token') || '';
    const ok = await subscribeToPush(token);
    setLoading(false);
    if (ok) setVisible(false);
  };

  const handleDismiss = () => {
    dismissPushPrompt();
    setVisible(false);
  };

  return (
    <div className="flex items-center gap-2 px-4 py-2.5 bg-brand-light border-t border-brand-border">
      <BellRing className="w-4 h-4 text-brand-500 flex-shrink-0" />
      <p className="text-xs text-brand-dark flex-1">
        Active les notifications pour ne rien manquer
      </p>
      <button
        onClick={handleEnable}
        disabled={loading}
        className="text-xs font-medium text-white bg-brand-500 hover:bg-brand-600 px-3 py-1 rounded-full transition-colors disabled:opacity-50"
      >
        {loading ? '...' : 'Activer'}
      </button>
      <button
        onClick={handleDismiss}
        className="text-brand-muted hover:text-brand-dark transition-colors"
        aria-label="Fermer"
      >
        <X className="w-3.5 h-3.5" />
      </button>
    </div>
  );
};

export default PushPermissionPrompt;
